const translations = {
  "en": {
    "last 24hrs": "last 24hrs"
  },
  "zh-tw": {
    "last 24hrs": "近 24 小時"
  }
};

export default translations;
